import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../css/Header.css';

export const Headercomponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);
  const logoRef = useRef(null);

  const links = [
    { name: 'Solutions', path: '/' },
    { name: 'Platform', path: '/product' },
    { name: 'Intelligence Products', path: '/intelligence_products' },
    { name: 'Protective Intelligence', path: '/protective_intelligence' },
    { name: 'Crime Maps', path: '/crime_map_gallery' },
    { name: 'About', path: '/about' },
  ];

  const closeMenu = () => setIsMenuOpen(false);

  const logoReRoute = () => {
    navigate('/');
    closeMenu();
  };

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedMenu = menuRef.current?.contains(event.target);
      const clickedButton = menuButtonRef.current?.contains(event.target);
      const clickedLogo = logoRef.current?.contains(event.target);

      if (!clickedMenu && !clickedButton && !clickedLogo) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

useEffect(() => {
  const handleScroll = () => {
    closeMenu();
    setIsScrolled(window.scrollY > 30);
  };

  handleScroll();

  window.addEventListener('scroll', handleScroll);

  return () => window.removeEventListener('scroll', handleScroll);
}, []);

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  return (
    <header
  className={`headercontainer ${isScrolled ? 'header-glass' : ''}`}
>
      <div className="headerinner">
        <button
          type="button"
          className="logo"
          onClick={logoReRoute}
          ref={logoRef}
          aria-label="Go to Weathervane Intel home page"
        >
          <img src="/weathervaneLogo.svg" alt="Weathervane Intel Logo" />
          <span className="brand-wordmark">Weathervane Intel</span>
        </button>

        <nav className="headerlinks" aria-label="Main navigation">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={isActive(link.path) ? 'active-link' : ''}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <Link
            to="/contact"
            className={`header-contact-button ${isActive('/contact') ? 'active-contact' : ''}`}
          >
            Contact
          </Link>

          <a
            href="https://app.weathervaneintel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="client-login-button"
          >
            Client Login
          </a>
        </div>

        <button
          type="button"
          className={`menuDropDown ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen((current) => !current)}
          ref={menuButtonRef}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </div>

      {isMenuOpen && (
        <nav className="dropdown-menu" ref={menuRef} aria-label="Mobile navigation">
          {links.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={isActive(link.path) ? 'active-link' : ''}
              onClick={closeMenu}
            >
              {link.name}
            </Link>
          ))}

          <Link
            to="/contact"
            className={`mobile-contact-link ${isActive('/contact') ? 'active-link' : ''}`}
            onClick={closeMenu}
          >
            Contact
          </Link>

          <a
            href="https://app.weathervaneintel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-login-link"
            onClick={closeMenu}
          >
            Client Login
          </a>
        </nav>
      )}
    </header>
  );
};
